// Curated interests (used until 4.5-B ships the taxonomy-backed source).
export const INTERESTS = [
  'Food & Dining','Music','Travel','Art & Culture','Fitness','Books','Movies & TV',
  'Technology','Fashion','Photography','Cooking','Volunteering','Entrepreneurship',
  'Wellness','Faith & Spirituality','Design','Podcasts','Writing','Live Music','Nature',
];

export const ACTIVITIES = [
  'Coffee walks','Hiking','Concerts','Museum visits','Cooking classes','Beach days',
  'Board games','Volunteering','Yoga','Trivia nights','Wine tasting','Book club',
  'Dance','Sports','Road trips','Runs','Photography walks','Farmers markets','Brunches',
];
